import validate from 'validate.js'

const constraints = {
  serviceId: {
    presence: true
  },
  updatedService: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
